import AppIcon from '../icons/AppIcon'
import styles from './BackButton.module.css'

export default function BackButton({ onClick }: { onClick: () => void }) {
  return (
    <button type="button" className={styles.back} onClick={onClick} aria-label="Back">
      <AppIcon icon="mdi:chevron-left" size={18} />
    </button>
  )
}
